var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTutorial({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 26,
    viewBox: "0 0 39 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 0L39 7.58131L19.5 15.114L4.95 9.47663C4.05 10.2056 3.4 11.372 3.3 12.6841H3.65C4.05 12.6841 4.35 12.9757 4.35 13.3645V15.1626C4.35 15.5514 4.05 15.843 3.65 15.843H3.4L4.35 25.271C4.4 25.6598 4.1 26 3.7 26H1.95C1.55 26 1.25 25.6598 1.25 25.271L2.25 15.843H2C1.6 15.843 1.25 15.5514 1.25 15.1626V13.3645C1.25 12.9757 1.6 12.6841 2 12.6841H2.55C2.65 11.2748 3.3 10.0598 4.2 9.18505L0 7.58131L19.5 0ZM18.95 16.4748L19.5 16.6692L20.05 16.4748L30.75 12.2953L31.55 20.8972C31.6 21.4804 31.2 21.7234 30.65 21.4804L26.45 19.3907C25.9 19.0991 25 19.1477 24.5 19.4393L20.45 21.6748C19.95 21.9664 19.05 21.9664 18.55 21.6748L14.5 19.4393C14 19.1477 13.1 19.0991 12.6 19.3907L8.35 21.4804C7.8 21.772 7.4 21.4804 7.45 20.8972L8.25 12.2953L18.95 16.4748Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.4068a0c5fd23b11030ff17a9fd9739c6.svg";
export { ForwardRef as ReactComponent };